import { ResourceTypeLink } from "@evergis/api";
import React, { FC } from "react";
import { useResourceType } from "../../../../hooks/useResourceType";
import { useViewType } from "../../hooks/useViewType";
import { CategoryFilter } from "../Filter/CategoryFilter";
import { Search } from "../Filter/Search";
import { FiltersCollapsed } from "../FiltersCollapsed/FiltersCollapsed";
import { FilterScreenBreakpoint } from "../FiltersCollapsed/types";
import { ResourceViewType } from "../ViewType/types";
import { Filters } from "./Filters";

import { FiltersAndSortsContainer, FiltersAndSortsExpanded } from "./styled";

export const FiltersAndSorts: FC = () => {
  const [resourceType] = useResourceType();
  const [viewType] = useViewType();

  let breakpoint = FilterScreenBreakpoint.All;

  if (resourceType === ResourceTypeLink.Project) {
    breakpoint = FilterScreenBreakpoint.Sort;
  } else if (resourceType === ResourceTypeLink.Layer && viewType !== ResourceViewType.Grid) {
    breakpoint = FilterScreenBreakpoint.GeometryAndServices;
  } else if (resourceType === ResourceTypeLink.Layer && viewType === ResourceViewType.Grid) {
    breakpoint = FilterScreenBreakpoint.All;
  } else if (resourceType === ResourceTypeLink.Table && viewType !== ResourceViewType.Grid) {
    breakpoint = FilterScreenBreakpoint.Geometry;
  } else if (resourceType === ResourceTypeLink.Table && viewType === ResourceViewType.Grid) {
    breakpoint = FilterScreenBreakpoint.GeometryAndSort;
  }

  return (
    <FiltersAndSortsContainer>
      <CategoryFilter />
      <Search />
      <FiltersAndSortsExpanded breakpoint={breakpoint}>
        <Filters />
      </FiltersAndSortsExpanded>
      <FiltersCollapsed breakpoint={breakpoint} />
    </FiltersAndSortsContainer>
  );
};
